<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="title"
        :icon="dashboardIcon"
        large="true"
        >
        <dean-table
            :data="tableData"
            :columns="tableColumns"
        ></dean-table>
        <dean-button primary="true" warning dialog-button @click.native="close()">close</dean-button>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
    // COMPONENTS
    deanTable,
    deanSectionTitle,
    deanSectionTitleItem,
    deanDialog,
    deanButton,
    dashboardIcon,
} from '@deanone/dean-components';
import { deanDialogBus } from '@/main';

@Component({
  components: {
    deanTable,
    deanSectionTitle,
    deanSectionTitleItem,
    deanDialog,
    deanButton,
    dashboardIcon,
  },
})

export default class DetailsDialog extends Vue {
  public dashboardIcon: object = dashboardIcon;
  @Prop() public payloadData!: {
    [key: string]: {
      [key: string]: string,
    };
  };

  get title() {
    return this.payloadData.title;
  }

  get tableData() {
    return this.payloadData.data;
  }

  get tableColumns() {
    return this.payloadData.columns;
  }

  public close() {
    deanDialogBus.$emit('close');
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';
</style>
